import { Box, Button, Menu, MenuItem, styled, useTheme } from "@mui/material";
import { Down, Up } from "assets/Icon";

import { useState } from "react";

function DropdownButton({ items, children, ...props }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickItem = (item) => {
    if (item?.onClick) {
      item?.onClick(item);

      handleClose();
    }
  };

  return (
    <>
      <ButtonStyle
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        {...props}
      >
        {children}

        {open ? (
          <Up color={theme.palette.text.main} />
        ) : (
          <Down color={theme.palette.text.main} />
        )}
      </ButtonStyle>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {items?.map((item, index) => (
          <>
            <MenuItem onClick={() => handleClickItem(item)} key={index}>
              {item?.name}
            </MenuItem>

            <Box sx={{ pl: 2 }}>
              {item?.children?.map((child, cIndex) => (
                <MenuItem
                  onClick={() => handleClickItem(child)}
                  key={`child-${cIndex}`}
                >
                  {child?.name}
                </MenuItem>
              ))}
            </Box>
          </>
        ))}
      </Menu>
    </>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  svg: {
    marginLeft: theme.spacing(0.75),
  },
}));

export default DropdownButton;
